export default __webpack_public_path__ + "static/media/PILOT.1871766b.png";